export class Model_CRM_BusinessType {

    public BusinessTypeName: string;
    public BusinessId: number;

}       
